import * as Sentry from "@sentry/react";
import { Routes } from "react-router-dom";

const SentryRoutes = Sentry.wrapReactRouterRouting(Routes);

export default SentryRoutes;
